import { useEffect, useRef, useState } from 'react';
import { cn, mergeClasses } from '#lib/helpers/class.js';
import setImagePosition from '#lib/helpers/image.js';
import { Spinner } from '#lib/components/loading.jsx';

export default function CoverPreview({ file, alt, className, width = 160, pt = 90 }) {
    const [imageLoaded, setImageLoaded] = useState(true);

    // Fa la proporzione tra le dimensioni originali e quelle attuali e posizona l'immagine nel container
    const imageRef = useRef(null);
    const imageWidth = imageRef.current?.clientWidth;
    const imageHeight = imageRef.current?.clientHeight;
    const containerRef = useRef(null);

    const [dx, setDx] = useState(0);
    const [dy, setDy] = useState(0);

    // Set the image position when the file changes and at the mounting of the component
    useEffect(() => {
        if (file && imageRef.current && containerRef.current) {
            const [deltaX, deltaY] = setImagePosition(imageWidth, imageHeight, file);
            setDx(deltaX);
            setDy(deltaY);
            if (imageLoaded) setImageLoaded(false);
        }
    }, [imageRef.current, containerRef.current, imageWidth, imageHeight, file, file?.coords]);

    // Set the image position when the window is resized
    useEffect(() => {
        const handleResize = () => {
            if (file && imageRef.current && containerRef.current) {
                const [deltaX, deltaY] = setImagePosition(imageWidth, imageHeight, file);
                setDx(deltaX);
                setDy(deltaY);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    });

    return (
        <div
            className={mergeClasses(`relative overflow-hidden rounded`, className)}
            style={{
                width,
                paddingTop: pt
            }}
            ref={containerRef}
        >
            <img
                ref={imageRef}
                src={
                    file instanceof File
                        ? URL.createObjectURL(file)
                        : file.src && !file.src.startsWith('upload_tmp')
                        ? file.src
                        : file.tempSrc
                }
                alt={alt}
                className={cn(`absolute top-0 left-0 min-w-full min-h-full object-cover`)}
                style={{ transform: `translate(${dx}px, ${dy}px)` }}
            />
            <div
                className={cn(
                    'transition-all duration-1000 absolute top-0 left-0 w-full h-full bg-neutral-100 ',
                    imageLoaded ? 'opacity-100' : 'opacity-0'
                )}
            >
                {imageLoaded && (
                    <div className="flex justify-center items-center h-full w-full">
                        <Spinner />
                    </div>
                )}
            </div>
        </div>
    );
}
